/* import __COLOCATED_TEMPLATE__ from './course-editor-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';

export default class CourseEditorCardComponent extends Component 
{
	@service store;
	
	@tracked isAddingNewCourseElement = false;

	@tracked newCEName = "";
	@tracked newCETimingPoint = null;
	@tracked selectedCEAfter = null;

	@tracked isAddingNewSegment = false;
	@tracked newSegmentName = "";
	@tracked newSegmentDescription = "";
	@tracked newSegmentStart = null;
	@tracked newSegmentEnd = null;
	@tracked newSegmentStartIsStart = false;
	@tracked newSegmentEndIsFinish = false;
	@tracked newSegmentDistance = null;
	
	get newCEAfter()
	{
		if(this.selectedCEAfter != null && this.selectedCEAfter != -1)
		{
			return this.selectedCEAfter;
		}
		
		if(this.selectedCEAfter == -1)
		{
			return null;
		}
		
		return this.args.course.courseElementsInCourseOrder.then(function(courseElements)
		{
			if(courseElements == null)
			{
				return null;
			}
		
			return courseElements[courseElements.length-1];
		});
	}
	
	async reorderCourseElements()
	{
		var order = 10;
		var courseElements = await this.args.course.courseElementsInCourseOrder;
		for(const ce of courseElements)
		{
			ce.order = order;
			try
			{
				await ce.save();
			}
			catch (error)
			{
				alert(error)
				return;
			}
			order+=10;
		};
	};
	
	@action
	async startAddingNewCourseElement()
	{
		// Default to adding after the last course element
		const courseElements = await this.args.course.courseElementsInCourseOrder;
		if(courseElements && courseElements.length > 0)
		{
			this.selectedCEAfter = courseElements[courseElements.length - 1];
		}
		else
		{
			this.selectedCEAfter = -1; // After Start
		}
		this.isAddingNewCourseElement = true;
	};

	@action
	cancelNewCourseElement(clickEvent)
	{
		this.isAddingNewCourseElement = false;
		this.newCETimingPoint = null;
		this.selectedCEAfter = null;
		this.newCEName = "";
	};
	
	@action
	async saveNewCourseElement(clickEvent)
	{	
		const store = this.store;
		//prevent form submit and page reload
		clickEvent.preventDefault();
		
		var courseElements = await this.args.course.courseElementsInCourseOrder;
		
		var prevCEOrder = 0;
		var nextCEOrder = 0;
		var newCEOrder = 0;
		if((await this.newCEAfter) == null)
		{
			prevCEOrder = 0;
			if(courseElements[0])
				nextCEOrder = courseElements[0].order;
			else
				nextCEOrder = 20;
		}
		else
		{
			prevCEOrder = (await this.newCEAfter).order;
			var foundCE = false;
			courseElements.forEach(function(ce)
			{
				if(ce.order > prevCEOrder && !foundCE)
				{
					foundCE = true;
					nextCEOrder = ce.order
				}
			});
			//if it was the last CE, we never found the next one
			//set to +20 so that diff/2 = 10
			if(nextCEOrder == 0)
			{
				nextCEOrder = prevCEOrder+20;
			}
		}
		
		if(nextCEOrder-prevCEOrder > 1)
		{
			newCEOrder = (nextCEOrder-prevCEOrder)/2+prevCEOrder;
		}
		else
		{
			await this.reorderCourseElements();
			
			if((await this.newCEAfter) == null)
			{
				prevCEOrder = 0;
				if(courseElements[0])
					nextCEOrder = courseElements[0].order;
				else
					nextCEOrder = 20;
			}
			else
			{
				prevCEOrder = (await this.newCEAfter).order;
				var foundCE = false;
				courseElements.forEach(function(ce)
				{
					if(ce.order > prevCEOrder && !foundCE)
					{
						foundCE = true;
						nextCEOrder = ce.order
					}
				});
				//if it was the last CE, we never found the next one
				//set to +20 so that diff/2 = 10
				if(nextCEOrder == 0)
				{
					nextCEOrder = prevCEOrder+20;
				}
			}
			newCEOrder = (nextCEOrder-prevCEOrder)/2+prevCEOrder;
		}
	
		const newCE = store.createRecord('course-element', 
		{
			name:this.newCEName,
			isPublic: true,
			order: Math.floor(newCEOrder),
			IntermediateTimingPointId: this.newCETimingPoint,
			CourseId: this.args.course
		});
		await newCE.save();
		await store.findRecord('course-element',newCE.id);
	
		this.isAddingNewCourseElement = false;
		this.newCETimingPoint = null;
		this.selectedCEAfter = null;
		this.newCEName = "";
	};
	
	@action
	async deleteCourseElement(element)
	{
		element.deleteRecord();
		
		try
		{
			await element.save();
		}
		catch (error)
		{
			alert(error)
			element.rollbackAttributes();
		}
	};
	
	@action
	async toggleIsPublic(element,changeEvent)
	{
		element.isPublic = changeEvent.target.checked;
		
		try
		{
			await element.save();
		}
		catch (error)
		{
			alert(error)
			element.rollbackAttributes();
		}
	};
	
	@action
	async selectNewCETimingPoint(selectEvent)
	{
		var tpId = selectEvent.target.value;
		if(tpId == "-")
		{
			this.newCETimingPoint = null;
		}
		else
		{
			const tp = await this.store.findRecord('IntermediateTimingPoint', tpId)
			this.newCETimingPoint = tp;
		}
	};
	
	@action
	async selectNewCEAfterTimingPoint(selectEvent)
	{
		var ceId = selectEvent.target.value;
		if(ceId == "Start")
		{
			this.selectedCEAfter = -1;
		}
		else
		{
			const ce = await this.store.findRecord('course-element', ceId)
			this.selectedCEAfter = ce;
		}
	};

	@action
	cancelNewSegment(clickEvent)
	{
		this.isAddingNewSegment = false;
		this.newSegmentName = "";
		this.newSegmentDescription = "";
		this.newSegmentStart = null;
		this.newSegmentEnd = null;
		this.newSegmentStartIsStart = false;
		this.newSegmentEndIsFinish = false;
		this.newSegmentDistance = null;
	};

	@action
	async saveNewSegment(clickEvent)
	{
		clickEvent.preventDefault();

		const newSegment = this.store.createRecord('segment',
		{
			name: this.newSegmentName,
			description: this.newSegmentDescription,
			CourseId: this.args.course,
			EventId: this.args.event,
			startCourseElementId: this.newSegmentStartIsStart ? null : this.newSegmentStart,
			endCourseElementId: this.newSegmentEndIsFinish ? null : this.newSegmentEnd,
			startIsStart: this.newSegmentStartIsStart,
			endIsFinish: this.newSegmentEndIsFinish,
			distance: this.newSegmentDistance
		});

		try
		{
			await newSegment.save();
		}
		catch (error)
		{
			alert(error);
			newSegment.rollbackAttributes();
			return;
		}

		this.isAddingNewSegment = false;
		this.newSegmentName = "";
		this.newSegmentDescription = "";
		this.newSegmentStart = null;
		this.newSegmentEnd = null;
		this.newSegmentStartIsStart = false;
		this.newSegmentEndIsFinish = false;
		this.newSegmentDistance = null;
	};

	@action
	async deleteSegment(segment)
	{
		segment.deleteRecord();

		try
		{
			await segment.save();
		}
		catch (error)
		{
			alert(error);
			segment.rollbackAttributes();
		}
	};

	@action
	async selectNewSegmentStart(selectEvent)
	{
		var ceId = selectEvent.target.value;
		if(ceId == "-")
		{
			this.newSegmentStart = null;
			this.newSegmentStartIsStart = false;
		}
		else if(ceId == "Start")
		{
			this.newSegmentStart = null;
			this.newSegmentStartIsStart = true;
		}
		else
		{
			const ce = await this.store.findRecord('CourseElement', ceId);
			this.newSegmentStart = ce;
			this.newSegmentStartIsStart = false;
		}
	};

	@action
	async selectNewSegmentEnd(selectEvent)
	{
		var ceId = selectEvent.target.value;
		if(ceId == "-")
		{
			this.newSegmentEnd = null;
			this.newSegmentEndIsFinish = false;
		}
		else if(ceId == "Finish")
		{
			this.newSegmentEnd = null;
			this.newSegmentEndIsFinish = true;
		}
		else
		{
			const ce = await this.store.findRecord('CourseElement', ceId);
			this.newSegmentEnd = ce;
			this.newSegmentEndIsFinish = false;
		}
	};

	@action
	async updateSegmentStart(segment, selectEvent)
	{
		var ceId = selectEvent.target.value;
		if(ceId == "-")
		{
			segment.startCourseElementId = null;
			segment.startIsStart = false;
		}
		else if(ceId == "Start")
		{
			segment.startCourseElementId = null;
			segment.startIsStart = true;
		}
		else
		{
			const ce = await this.store.findRecord('CourseElement', ceId);
			segment.startCourseElementId = ce;
			segment.startIsStart = false;
		}

		try
		{
			await segment.save();
		}
		catch (error)
		{
			alert(error);
			segment.rollbackAttributes();
		}
	};

	@action
	async updateSegmentEnd(segment, selectEvent)
	{
		var ceId = selectEvent.target.value;
		if(ceId == "-")
		{
			segment.endCourseElementId = null;
			segment.endIsFinish = false;
		}
		else if(ceId == "Finish")
		{
			segment.endCourseElementId = null;
			segment.endIsFinish = true;
		}
		else
		{
			const ce = await this.store.findRecord('CourseElement', ceId);
			segment.endCourseElementId = ce;
			segment.endIsFinish = false;
		}

		try
		{
			await segment.save();
		}
		catch (error)
		{
			alert(error);
			segment.rollbackAttributes();
		}
	};
};